export default "<p>task-equivalence-transformation works!</p>\n"